<template>
  <main>
    <div
      class="
        container
        min-vh-100
        d-flex
        justify-content-center
        align-items-center
      "
    >
      <div class="row justify-content-center">
        <div
          class="
            col-sm-11 col-md-8 col-lg-7
            bg-white
            rounded
            shadow
            z-depth-1
            my-2
            wow
            fadeIn
            p-0
          "
        >
          <div class="row">
            <!-- کادر رنگی سمت راست -->
            <div
              class="
                col-3
                bg-dark
                d-flex
                flex-column
                justify-content-between
                align-items-center
                rounded-right
                shadow
                z-depth-1
                p-0
                py-3
              "
            >
              <!-- لوگو و نام نرم افزار -->
              <div class="row">
                <div class="col text-center p-0">
                  <img
                    class="img-fluid px-4"
                    :src="ImageUrl + 'LogoSite.png'"
                    alt="LogoSite"
                  />
                  <span class="text-white" style="font-size: 12px"
                    >سامانه مالی پرش</span
                  >
                </div>
              </div>

              <!-- نگارش و امضاء -->
              <div class="row">
                <div class="col text-center p-0">
                  <span class="text-white d-block"
                    >نگارش : {{ getVersionApp }}</span
                  >
                  <span class="text-white d-block mt-2">پارس رایانه شاپرک</span>
                </div>
              </div>
            </div>

            <!-- مرکز فرم ورود -->
            <div class="col-9 p-5 p-md-5 d-flex flex-column text-right">
              <h4 class="mb-4 text-danger text-center">
                <strong>محدودیت دسترسی {{blockIPByManager == false ? 'موقت' : 'دائم'}}</strong>
              </h4>
              <div>
                <h6 class="text-center" style="line-height: 32px">
                  دسترسی شما به سایت به صورت {{blockIPByManager == false ? 'موقت' : 'دائم'}} محدود شده است !
                  <br />
                  {{blockIPByManager == false 
                  ? 'لطفا پس از پایان مدت انتظار ، مجدد تلاش نمایید .' 
                  : 'جهت پیگیری با مدیر سامانه تماس بگیرید .'
                  }}
                </h6>
                <br v-if="blockIPByManager == false"/>
                <div
                  class="
                    text-info
                    w-100
                    d-flex
                    justify-content-center
                    align-items-center
                  "
                  v-if="blockIPByManager == false"
                >
                  <span class="h6 p-0 m-0 ml-2">مدت انتظار : </span>
                  <span class="h2 p-0 m-0">
                    {{ timeLeft }}
                  </span>
                  <!-- <span class="h6 p-0 m-0 mr-2">دقیقه</span> -->
                </div>
                <br />
                <div class="text-center">
                  <a
                    v-bind:style="
                      changeRoute == false
                        ? 'display: none; pointer-events : none; background-color: #82b1ff!important;'
                        : 'display: block; pointer-events : auto; background-color: #007bff;'
                    "
                    class="btn btn-lg btn-primary"
                  >
                    ورود به سایت
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { newRoutes } from "../../main";

export default {
  data() {
    return {
      intervalTimer: null,
      selectedTimeendTime: 0,
      timeLeft: "05:00",
      endTime: "00:00",
      changeRoute: false,
      blockIPByManager: false,
    };
  },
  mounted() {
    // دریافت مدت انتظار از سرور
    this.getBlockIPTime();
  },
  // components: {
  //   VueCountdownTimer
  // },
  computed: {
    ImageUrl() {
      // بازیابی آدرس تصاویر
      return this.$store.getters.getImageUrl;
    },
    getVersionApp() {
      // بازیابی شماره نگارش نرم افزار
      return this.$store.getters.getVersionApp;
    },
  },
  methods: {
    async getBlockIPTime() {
      // دریافت مدت مسدود شدن دسترسی از سرور
      var intBlockTime = await this.$store.dispatch("getBlockIPTime");
      // آیا آی پی توسط مدیر به طور دائم قفل شده است ؟
      if(intBlockTime != -1){
        // شمارش معکوس هنگام ایجاد فرم
        this.setTime(intBlockTime);
      } else {
        // آی پی به طور دائم توسط مدیر قفل شده است
        this.blockIPByManager = true;
      }
    },
    setTime(seconds) {
      clearInterval(this.intervalTimer);
      this.timer(seconds);
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + seconds * 1000;
      this.displayTimeLeft(seconds);

      this.selectedTime = seconds;
      // this.initialTime = seconds;
      // this.displayEndTime(end);
      this.countdown(end);
    },
    countdown(end) {
      // this.initialTime = this.selectedTime;
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);

        if (secondsLeft <= 0) {
          this.endTime = 0;
          clearInterval(this.intervalTimer);
          this.changeRoute = true;
          newRoutes.push("Login");
          return;
        }
        this.displayTimeLeft(secondsLeft);
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
      const day = parseInt(((secondsLeft / 60) / 60) / 12);
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;

      // console.log(minutes + ' | ' + seconds);

      this.timeLeft =
        (day != 0 
        ? 
          day.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        }) + ":"
        : ''
        ) + 
        minutes.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        }) +
        ":" +
        seconds.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        });
    },
    // displayEndTime(timestamp) {
    //   const end = new Date(timestamp);
    //   const hour = end.getHours();
    //   const minutes = end.getMinutes();

    //   // console.log(hour + ' | ' + minutes);

    //   this.endTime =
    //     hour.toLocaleString("en-US", {
    //       minimumIntegerDigits: 2,
    //       useGrouping: false,
    //     }) +
    //     ":" +
    //     minutes.toLocaleString("en-US", {
    //       minimumIntegerDigits: 2,
    //       useGrouping: false,
    //     });
    // },
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/BlockIP/BlockIP.vue